import * as React from 'react';
import * as classes from './HeaderedContent.scss';
import logo from '../assets/ls_logo_horizontal_white.svg';
import * as intl from 'react-intl-universal';

export interface Props {
  children: any;
  isFooterVisible?: boolean;
  isHelpVisible?: boolean;
  loggingId?: string;
}

const lifesizeAddress = 'lifesize.com';
const lifesizeUrl = 'http://www.lifesize.com';

const HeaderedContent: React.FunctionComponent<Props> = props => {
  return (
    <div className={classes.container}>
      <header>
        <div className={classes.logoContainer}>
          <a target="_blank" href={lifesizeUrl}>
            <img src={logo} className={classes.logo} />
          </a>
        </div>
        {props.isHelpVisible && (
          <a className={classes.headerButton} onClick={() => alert(intl.get('clicked_help'))}>
            <span className={`icon icon-help-outline ${classes.icon}`} />
          </a>
        )}
        {props.loggingId && (
          <div className={classes.supportId}><p>{intl.get('logging_support_id', {loggingId: props.loggingId})}</p></div>
        )}
      </header>
      {props.children}
      {props.isFooterVisible && (
        <footer>
        <span className={classes.footerText}>{intl.getHTML('footer', { targetUrl: lifesizeUrl, targetAddress: lifesizeAddress })}</span>
      </footer>
      )}
    </div>
  );
};

export default HeaderedContent;



// WEBPACK FOOTER //
// ./src/components/HeaderedContent.tsx